Controller.$inject = ['$scope', '$timeout'];

function Controller($scope, $timeout) {
    const self = this;
    self.showLegend = false;
    self.inputFocused = false;
    self.isOpen = false;

    self.$postLink = () => {
        self.showArrow = (self.type === 'text' || typeof self.showArrow !== 'undefined') ? self.showArrow : true;
    };

    self.handleFocus = () => {
        self.isOpen = true;
        if (self.labelVariant === 'outlined') {
            self.showLegend = true;
            self.inputFocused = true;
        }
    };

    self.handleBlur = () => {
        self.isOpen = false;
        if (!self.ngModel) {
            self.showLegend = false;
        }
        self.inputFocused = false;
    };

    const timePickerFocusHandler = $scope.$on('timePickerInputFocused', self.handleFocus);
    const timePickerBlurHandler = $scope.$on('timePickerInputBlured', self.handleBlur);

    self.setValidateTime = (data) => {
        if (self.validateTime) {
            return self.validateTime({value: data.value});
        } else {
            return data.value;
        }
    };

    self.handleChange = ($event) => {
        $timeout(() => {
            self.onChange($event);
        })
    };

    $scope.$on('$destroy', () => {
        timePickerFocusHandler();
        timePickerBlurHandler();
    });
}

export function HuiInputTimePicker() {
    return {
        restrict: 'E',
        scope: true,
        bindToController: {
            ngModel: '=',
            labelVariant: '@',
            iconPosition: '@',
            disabled: '<',
            hName: '@',
            hasError: '<',
            placeholder: '@',
            appendText: '@',
            options: '<?',
            timeFormat: '@',
            minuteStep: '<',
            hourStep: '<',
            validateTime: '&?',
            timeType: '@',
            date: '=',
            onOptionSelect: '&',
            onChange: '&',
            onMomentModelChange: '&',
            showArrow: '<?',
            type: '@',
            fullWidth: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            label: '?huiInputLabel',
            icon: '?huiInputIcon'
        },
        template: ($element, $attrs) => {
            return `
              <hui-input-base
                    label-variant="{{$huiCtrl.labelVariant}}"
                    icon-position="{{$huiCtrl.iconPosition || 'start'}}"
                    has-error="$huiCtrl.hasError"
                    show-legend="$huiCtrl.showLegend"
                    input-focused="$huiCtrl.inputFocused"
                    model-value="$huiCtrl.ngModel"
                    disabled="$huiCtrl.disabled"
                    full-width="$huiCtrl.fullWidth">
                  
                    <hui-input-base-label ng-transclude ng-transclude-slot="label"></hui-input-base-label>
                    <hui-input-base-icon ng-if="$huiCtrl.type == 'text'"><i class="fa fa-clock"></i></hui-input-base-icon>
                  
                   <h-timepicker
                        class="flex-grow-1"
                        ng-if="$huiCtrl.type != 'text'"
                        name="{{$huiCtrl.hName}}"
                        ng-model="$huiCtrl.ngModel"
                        placeholder="{{$huiCtrl.labelVariant !== 'outlined' ? $huiCtrl.placeholder : ''}}"
                        append-text="$huiCtrl.appendText"
                        options="$huiCtrl.options"
                        time-format="{{$huiCtrl.timeFormat}}"
                        minute-step="$huiCtrl.minuteStep"
                        hour-step="$huiCtrl.hourStep"
                        validate-time="$huiCtrl.setValidateTime({value: value})"
                        time-type="{{$huiCtrl.timeType}}"
                        date="$huiCtrl.date"
                        ng-disabled="$huiCtrl.disabled"
                        ng-focus="$huiCtrl.handleFocus()"
                        ng-blur="$huiCtrl.handleBlur()"
                        ng-change="$huiCtrl.handleChange($event)"
                        on-moment-model-change="$huiCtrl.onMomentModelChange({value: value})"
                        on-option-select="$huiCtrl.onOptionSelect({option: option})"
                        >
                    </h-timepicker>
                    
                   <input
                        ng-if="$huiCtrl.type == 'text'"
                        type="text"
                        name="{{$huiCtrl.hName}}"
                        class="hui-base-input"
                        placeholder="{{$huiCtrl.labelVariant !== 'outlined' ? $huiCtrl.placeholder : ''}}"
                        ng-model="$huiCtrl.ngModel"
                        ng-disabled="$huiCtrl.disabled"
                        ng-change="$huiCtrl.handleChange($event)"
                        ng-focus="$huiCtrl.handleFocus()"
                        ng-blur="$huiCtrl.handleBlur()"
                        autocomplete="off"
                   />
                    
                    <i class="fa hui-select-arrow text-primary"
                       ng-if="$huiCtrl.showArrow"
                       ng-class="{'fa-chevron-down': !$huiCtrl.isOpen,
                                  'fa-chevron-up': $huiCtrl.isOpen,
                                  'icon-disabled': $huiCtrl.disabled}"
                       aria-hidden="true"></i>
                </hui-input-base>
             `;
        }
    };
}



